import { useGetColor } from "PFCore/hooks/use_get_color";
import { Color } from "PFCore/types";
import { IconName } from "PFTheme/graphics/icons";
import { SVGProps } from "react";
import { useCallback, useState } from "react";
import { RequireExactlyOne } from "type-fest";

import { IconDefaultSize, IconSize, IconSizeTable } from "./icon.utils";

export type IconProps = Omit<SVGProps<SVGElement>, "color" | "ref"> &
  Partial<
    RequireExactlyOne<{
      color?: Color;
      fill?: SVGProps<SVGElement>["fill"];
    }>
  > & {
    name: IconName;
    size?: IconSize;
  };

export const Icon = ({ name, color, fill, size = IconDefaultSize, ...svgProps }: IconProps) => {
  const [pathDefaultColor, setPathDefaultColor] = useState<string | null>(null);
  const getColor = useGetColor();

  const ref = useCallback((node: HTMLDivElement | null) => {
    if (!node) {
      return;
    }

    setPathDefaultColor(node.getElementsByTagName("path")[0]?.getAttribute("fill"));
    node.getElementsByTagName("path")[0]?.removeAttribute("fill");
  }, []);

  // eslint-disable-next-line @typescript-eslint/no-require-imports
  const IconSvg = require(`PFTheme/graphics/icons/${name}.svg`).default;

  const length = IconSizeTable[size];

  return (
    <IconSvg
      data-name={name}
      ref={ref}
      width={length}
      height={length}
      {...svgProps}
      style={{ minWidth: length, minHeight: length, ...(svgProps.style || {}) }}
      fill={fill || (color && getColor(color)) || pathDefaultColor}
    />
  );
};
